import React, { useEffect, useState } from "react";
import WeatherIcon from "@appsinti/ui-core/weather/Icon";
import CurrentTemperature from "@appsinti/common-utils/interfaces/weather/CurrentTemperature";

import { useTemperature } from "@appsinti/temperature-provider";
import styled from "styled-components";
import initCurrentTemperature from "./data";

const Container = styled.div`
  width: 100%;
  display: flex;
  border-radius: 3px;
  padding: 0px 2px;

  &:hover, &:focus {
    transform: scale(.95);
    transition-duration: .5s;
    transition-property: scale;
  }
`;

const IconContainer = styled.div`
  max-width: 15px;
  flex:  0 0 15px;
  margin-right: 3px;
  align-items: start;
  margin-bottom: -3px;
`;

const Mini: React.FC<{ appId: number, config?: {[key: string]: boolean} }>
  = ({ appId, config = {showIcon: false} }) => {

  const { temperatureObject } = useTemperature();
  const [temperature, setTemperature] =
    useState<CurrentTemperature | null>(null);

  useEffect(() => {
    initCurrentTemperature(appId, setTemperature);
  }, []);

  return temperature && (
    <Container>
      {config.showIcon && (
        <IconContainer>
          <WeatherIcon 
            name={temperature.icon} 
            isDaytime={temperature.isDaytime}
          />
        </IconContainer>
      )}
      
      {temperatureObject(temperature.temperature)}
    </Container>
  );
};

export default Mini;
